module.exports = __webpack_public_path__ + "img/left-0.ff90cd3c.jpg";